import React, { useState, useEffect } from "react";

const LoadingScreen = ({ onFinish }) => {

  const [fadeOut, setFadeOut] = useState(false);
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let start;
    let frame;
    const duration = 1800;
    function animateRing(ts) {
      if (!start) start = ts;
      const elapsed = ts - start;
      const pct = Math.min(elapsed / duration, 1);
      setProgress(pct);
      if (pct < 1) {
        frame = requestAnimationFrame(animateRing);
      } else {
        setFadeOut(true);
        setTimeout(() => onFinish(), 700);
      }
    }
    frame = requestAnimationFrame(animateRing);
    return () => cancelAnimationFrame(frame);
  }, [onFinish]);

  return (
    <div
      className={`fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-white transition-opacity duration-700 ${
        fadeOut ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
    >

      {/* Logo with circular progress ring around it */}
      <div className="relative mb-6 w-56 h-56 flex items-center justify-center">
        {/* Anneau de chargement plus grand */}
        <svg className="absolute inset-0 w-full h-full" viewBox="0 0 224 224">
          <circle cx="112" cy="112" r="106" fill="none" strokeWidth="4" stroke="#e5e7eb" />
          <circle
            cx="112" cy="112" r="106" fill="none" strokeWidth="6"
            stroke="url(#gradient)" strokeLinecap="round"
            strokeDasharray="666"
            strokeDashoffset={666 - 666 * progress}
            style={{ transition: 'stroke-dashoffset 0.1s linear' }}
          />
          <defs>
            <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#1e40af" />
              <stop offset="50%" stopColor="#059669" />
              <stop offset="100%" stopColor="#f97316" />
            </linearGradient>
          </defs>
        </svg>
        {/* Logo */}
        <img
          src="/imgs/WFL.png"
          alt="Women Future Life"
          className="w-40 h-40 object-contain relative z-10 animate-scaleIn"
        />
      </div>

      {/* Org name */}
      <h1 className="text-2xl md:text-3xl font-bold text-gray-800 tracking-wide animate-fadeInUp" style={{ animationDelay: "0.3s", animationFillMode: "both" }}>
        <span className="text-blue-800">Women</span>{" "}
        <span className="text-green-700">Future</span>{" "}
        <span className="text-orange-500">Life</span>
      </h1>

      {/* Tagline */}
      <p className="mt-2 text-sm text-gray-400 animate-fadeInUp" style={{ animationDelay: "0.6s", animationFillMode: "both" }}>
        Défendre, protéger et promouvoir
      </p>

      {/* Removed bottom progress bar */}
    </div>
  );
};

export default LoadingScreen;
